import React from "react";
import "../../assets/scss/components/generic/toggle.scss";

export interface IToggleProps {
	isOn: boolean; // true if toggle is on, else false
	children: string | React.ReactElement; // text/element for label
	name: string; // name for input checkbox
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
}

const Toggle: React.FC<IToggleProps> = (props: IToggleProps) => {
	return (
		<label className="toggle">
			<span className="tgl_text">{props.children}</span>
			<span className="toggle_outer">
				<input type="checkbox" onChange={props.onChange} checked={props.isOn} />
				<span className="toggle_inner"></span>
			</span>
		</label>
	);
};

export default Toggle;
